"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  userActions: true,
  scopeMappings: true,
  userAclParser: true,
  verifyScope: true,
  isVistaApplication: true,
  APP_CALLBACK_ACTION: true,
  postMessageToNativeApp: true,
  appHardwareBackEventListener: true,
  openInNewWindow: true,
  openUrl: true,
  isWebviewEnv: true,
  isAndroidApp: true,
  isIOSApp: true,
  isTestMode: true,
  sessionSwitcherEnabled: true,
  switchToTestMode: true,
  switchToLiveMode: true,
  toggleMerchantSession: true,
  getCurrentSession: true,
  getSessionCookies: true,
  joinUrls: true,
  extractParams: true,
  isConsolidatedDashboardEnabled: true,
  isConsolidatedDashboard: true,
  getConsolidatedUsersDetails: true,
  getSelectedConsolidatedMids: true,
  setSelectedConsolidatedMids: true,
  clearSelectedConsolidatedMids: true
};
Object.defineProperty(exports, "userActions", {
  enumerable: true,
  get: function get() {
    return _constants.userActions;
  }
});
Object.defineProperty(exports, "scopeMappings", {
  enumerable: true,
  get: function get() {
    return _constants.scopeMappings;
  }
});
Object.defineProperty(exports, "userAclParser", {
  enumerable: true,
  get: function get() {
    return _utils.userAclParser;
  }
});
Object.defineProperty(exports, "verifyScope", {
  enumerable: true,
  get: function get() {
    return _utils.verifyScope;
  }
});
Object.defineProperty(exports, "isVistaApplication", {
  enumerable: true,
  get: function get() {
    return _utils2.isVistaApplication;
  }
});
Object.defineProperty(exports, "APP_CALLBACK_ACTION", {
  enumerable: true,
  get: function get() {
    return _webview.APP_CALLBACK_ACTION;
  }
});
Object.defineProperty(exports, "postMessageToNativeApp", {
  enumerable: true,
  get: function get() {
    return _webview.postMessageToNativeApp;
  }
});
Object.defineProperty(exports, "appHardwareBackEventListener", {
  enumerable: true,
  get: function get() {
    return _webview.appHardwareBackEventListener;
  }
});
Object.defineProperty(exports, "openInNewWindow", {
  enumerable: true,
  get: function get() {
    return _webview.openInNewWindow;
  }
});
Object.defineProperty(exports, "openUrl", {
  enumerable: true,
  get: function get() {
    return _webview.openUrl;
  }
});
Object.defineProperty(exports, "isWebviewEnv", {
  enumerable: true,
  get: function get() {
    return _webview.isWebviewEnv;
  }
});
Object.defineProperty(exports, "isAndroidApp", {
  enumerable: true,
  get: function get() {
    return _webview.isAndroidApp;
  }
});
Object.defineProperty(exports, "isIOSApp", {
  enumerable: true,
  get: function get() {
    return _webview.isIOSApp;
  }
});
Object.defineProperty(exports, "isTestMode", {
  enumerable: true,
  get: function get() {
    return _merchantSession.isTestMode;
  }
});
Object.defineProperty(exports, "sessionSwitcherEnabled", {
  enumerable: true,
  get: function get() {
    return _merchantSession.sessionSwitcherEnabled;
  }
});
Object.defineProperty(exports, "switchToTestMode", {
  enumerable: true,
  get: function get() {
    return _merchantSession.switchToTestMode;
  }
});
Object.defineProperty(exports, "switchToLiveMode", {
  enumerable: true,
  get: function get() {
    return _merchantSession.switchToLiveMode;
  }
});
Object.defineProperty(exports, "toggleMerchantSession", {
  enumerable: true,
  get: function get() {
    return _merchantSession.toggleMerchantSession;
  }
});
Object.defineProperty(exports, "getCurrentSession", {
  enumerable: true,
  get: function get() {
    return _merchantSession.getCurrentSession;
  }
});
Object.defineProperty(exports, "getSessionCookies", {
  enumerable: true,
  get: function get() {
    return _merchantSession.getSessionCookies;
  }
});
Object.defineProperty(exports, "joinUrls", {
  enumerable: true,
  get: function get() {
    return _commonUtils.joinUrls;
  }
});
Object.defineProperty(exports, "extractParams", {
  enumerable: true,
  get: function get() {
    return _utmParameter.extractParams;
  }
});
Object.defineProperty(exports, "isConsolidatedDashboardEnabled", {
  enumerable: true,
  get: function get() {
    return _consolidated.isConsolidatedDashboardEnabled;
  }
});
Object.defineProperty(exports, "isConsolidatedDashboard", {
  enumerable: true,
  get: function get() {
    return _consolidated.isConsolidatedDashboard;
  }
});
Object.defineProperty(exports, "getConsolidatedUsersDetails", {
  enumerable: true,
  get: function get() {
    return _consolidated.getConsolidatedUsersDetails;
  }
});
Object.defineProperty(exports, "getSelectedConsolidatedMids", {
  enumerable: true,
  get: function get() {
    return _consolidated.getSelectedConsolidatedMids;
  }
});
Object.defineProperty(exports, "setSelectedConsolidatedMids", {
  enumerable: true,
  get: function get() {
    return _consolidated.setSelectedConsolidatedMids;
  }
});
Object.defineProperty(exports, "clearSelectedConsolidatedMids", {
  enumerable: true,
  get: function get() {
    return _consolidated.clearSelectedConsolidatedMids;
  }
});

var _constants = require("./userAclHelpers/constants");

var _utils = require("./userAclHelpers/utils");

var _utils2 = require("./vista/utils");

var _webview = require("./utils/webview");

var _merchantSession = require("./utils/merchantSession");

var _commonUtils = require("./utils/commonUtils");

var _utmParameter = require("./utils/utmParameter");

var _clevertap = require("./utils/clevertap");

Object.keys(_clevertap).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _clevertap[key];
    }
  });
});

var _Browser = require("./utils/Browser");

Object.keys(_Browser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Browser[key];
    }
  });
});

var _consolidated = require("./utils/consolidated");